import { useAppDispatch } from "hooks/reduxHooks";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { doLogout } from "store/slices/authSlice";

const NotFoundRedirect = () => {
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(doLogout());
    }, []);

    return <Navigate to="/auth/login" replace />;
};

export default NotFoundRedirect;